import { Component, OnInit, Input } from '@angular/core';
import { ResourcesCssService } from '../../pages/resources/resources-css.service'
import { PageHeaderCommands } from '../page-header/page-header.commands'
import { Article } from '../../models/article'
import { Router } from '@angular/router';

@Component({
  selector: 'app-blog-navigation',
  templateUrl: './blog-navigation.component.html',
  styleUrls: ['./blog-navigation.component.scss'],
})
export class BlogNavigationComponent implements OnInit {

  @Input() articles: Article[]
  isSelected: boolean = false
  url: string = ''

  currentPage: number
  itemsPerPage: number
  viewChecked: boolean

  @Input() showHeader: boolean = true

  constructor(public commands: PageHeaderCommands,
    public resourcesCssService: ResourcesCssService,
    private router: Router) { }

  ngOnInit() {
    this.url = this.router.url.slice(6)
    this.viewChecked = false
    this.currentPage = 1
    this.itemsPerPage = 10
  }

  gotoArticle(article: Article) {
    this.router.navigateByUrl('blog/' + article.slug);
    this.viewChecked = false
  }

  isCurrentArticle(url: string): boolean {
    return this.url === url
  }

  goToTeacherNotes() {
    this.router.navigateByUrl('teacher-notes')
  }

  // Pagination functions
  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  }

  goToPageIndex(index: number) {
    if (index >= 1 && index <= this.totalPages) {
      this.currentPage = index
    }
  }

  get items(): Article[] {
      if (this.articles !== undefined) {
        if (!this.viewChecked) {
          this.articles.map((value: Article, index: number) => {
            if (value.slug === this.url) {
              this.currentPage = Math.ceil((index + 1) / this.itemsPerPage)
              this.viewChecked = true
            }
          });
        }

        const lowerIndex = (this.currentPage - 1) * this.itemsPerPage
        const upperIndex = (this.currentPage * this.itemsPerPage) - 1

        return this.articles.map((value: Article, index: number) => {
          if (index >= lowerIndex && index <= upperIndex) {
            return value
          }
        }).filter(x => x !== undefined)
      } else {
        this.viewChecked = false
      }
      return []
  }

  get totalItems(): number {
    if (this.articles !== undefined) {
      return this.articles.length
    }
    return 0
  }

  get totalPages(): number {
    if (this.articles !== undefined) {
      return Math.floor((this.totalItems / this.itemsPerPage) + (this.totalItems % this.itemsPerPage > 0 ? 1 : 0))
    }
    return 1
  }

  get prevClass(): string {
    return this.currentPage === 1 ? 'disabled' : '';
  }

  get nextClass(): string {
    return this.currentPage === this.totalPages ? 'disabled' : '';
  }
}
